import {
  type VerdictMethod,
  type VerdictProvenanceFields,
} from "../../../../models/audit/analyticsColumnResult";

/**
 * The provenance fields plus the user an override names, which is everything a
 * surface needs to say who concluded a verdict.
 *
 * `userId` is optional because the grid summary's schema does not require it,
 * and nullable because an override can outlive the auditor who made it.
 */
export type VerdictConclusionFields = VerdictProvenanceFields & {
  userId?: string | null;
};

const CONCLUDED_BY_MIDSHIP = "Concluded by Midship";
const CONCLUDED_BY_AN_AUDITOR = "Concluded by an auditor";

/**
 * Who concluded the verdict, as every surface that says it — the review pane's
 * line under the conclusion (`VerdictProvenance`) and the grid cell's
 * conclusion affordance (`AnalyticsConclusionCard`) — says it.
 *
 * A judgment and a refusal both read as Midship's: either way no auditor wrote
 * the verdict. An override reads as the auditor's, by name where one is known;
 * where the verdict names no user, or the name has not been or could not be
 * looked up, it says an auditor did rather than guess who.
 */
export function concludedByLine(
  method: VerdictMethod,
  auditorName: string | null,
): string {
  switch (method) {
    case "llm_judgment":
    case "pipeline_refusal":
      return CONCLUDED_BY_MIDSHIP;
    case "human_override":
      return auditorName === null
        ? CONCLUDED_BY_AN_AUDITOR
        : `Concluded by ${auditorName}`;
  }
}
